import { Injectable } from '@angular/core';
import { AuthValidGuard } from './auth-valid.guard';
import { ApplicationAccessKey } from '../../../../common/models/application.interface';

@Injectable()
export class HybridAuthValidGuard extends AuthValidGuard {
    framed: boolean = true;
    isUserAuthorized(enabledApps: string[]): boolean {
        return enabledApps.includes(ApplicationAccessKey.CAMPAIGNS);
    }
}
